import { Popover } from "@base-ui-components/react";

export namespace PopoverRoot {
	export type ElementName = "Popover.Root";
	export type ElementType = HTMLElement;
	export type Props = Popover.Root.Props;
}

export const PopoverRoot = (componentProps: PopoverRoot.Props) => {
	const { children, ...restProps } = componentProps;

	return <Popover.Root {...restProps}>{children}</Popover.Root>;
};
